function injectScript(src, attributes = {}) {
	return new Promise((resolve, reject) => {
		// Check if already loaded
		const existing = document.querySelector(`script[src="${src}"]`);
		if (existing) {
			resolve();
			return;
		}

		const script = document.createElement('script');
		script.src = src;
		script.async = true;
		Object.entries(attributes).forEach(([key, value]) => {
			script.setAttribute(key, value);
		});
		script.onload = resolve;
		script.onerror = reject;
		document.head.appendChild(script);
	});
}

export async function loadGoogleAnalytics(measurementId) {
	if (window._gaLoaded) return;

	await injectScript(
		`https://www.googletagmanager.com/gtag/js?id=${measurementId}`,
		{ 'data-consent-category': 'analytics' }
	);

	window.dataLayer = window.dataLayer || [];
	function gtag() { window.dataLayer.push(arguments); }
	window.gtag = gtag;
	gtag('js', new Date());
	gtag('config', measurementId);
	window._gaLoaded = true;
}

export async function loadGoogleAdSense(publisherId) {
	if (window._adsenseLoaded) return;

	await injectScript(
		`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`,
		{
			'data-consent-category': 'marketing',
			crossorigin: 'anonymous',
		}
	);
	window._adsenseLoaded = true;
}

export async function loadFirebaseAnalytics() {
	if (window._firebaseAnalyticsLoaded) return;

	const isFirebaseHosting = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
	const firebaseBase = isFirebaseHosting ? '/__/firebase' : 'https://www.gstatic.com/firebasejs';
	const firebaseVersion = '8.6.1';

	await injectScript(`${firebaseBase}/${firebaseVersion}/firebase-app.js`, {
		'data-consent-category': 'analytics',
	});
	await injectScript(`${firebaseBase}/${firebaseVersion}/firebase-analytics.js`, {
		'data-consent-category': 'analytics',
	});

	if (isFirebaseHosting) {
		await injectScript('/__/firebase/init.js', {
			'data-consent-category': 'analytics',
		});
	} else {
		// On localhost, initialize Firebase manually with config from env
		if (window.firebase && window.firebase.apps && window.firebase.apps.length === 0) {
			const config = {
				apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
				projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
				appId: process.env.REACT_APP_FIREBASE_APP_ID,
				measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
			};
			if (config.apiKey) {
				window.firebase.initializeApp(config);
				window.firebase.analytics();
			}
		}
	}

	window._firebaseAnalyticsLoaded = true;
}
